import { memo, useState } from "react";
import { Box } from "@mui/material";

import { useSondertagContext } from "../context/sondertagContext";
import { useAppContext } from "../../../2_ksbHub/context/appContext";

import SondertagMain from "./SondertagMain";

import SondertageDialogs from "./SondertageDialogs";
import SondertageAlerts from "./SondertageAlerts";
import SondertageActions from "./SondertageActions";

import useSondertagActions from "../hooks/useSondertagActions";
import useSonderEventLock from "../hooks/useSonderEventLock";
import useSonderEventTemplates from "../hooks/useSonderEventTemplates";
import AppContentWrapper from "../../../2_ksbHub/components/AppContentWrapper";

function SondertageContent({ viewMode, dialogs }) {
  const {
    selectedSchoolyear,
    schoolyears,
    selectedSonderEvent,
    sondertage,
    isASondertageEventAdmin,
  } = useSondertagContext();

  const { isTeacherView, isMobile } = useAppContext();

  const [errorMessage, setErrorMessage] = useState("");

  const { sondertagTemplates, sonderEventTemplates } =
    useSonderEventTemplates();

  const { showUnlockedToast, setShowUnlockedToast } = useSonderEventLock();

  const actions = useSondertagActions();

  return (
    <Box
      sx={{
        flex: 1,
        marginTop: isMobile ? 1 : 0,
        display: "flex",
        flexDirection: "column",
      }}
    >
      {/* CONTENT */}
      <AppContentWrapper padding={false} gap={1.2} scrollable={false}>
        <SondertagMain viewMode={viewMode} dialogs={dialogs} />

        {isASondertageEventAdmin && !isTeacherView && (
          <SondertageActions
            isASondertageEventAdmin={isASondertageEventAdmin}
            isTeacherView={isTeacherView}
            selectedSonderEvent={selectedSonderEvent}
            actions={actions}
            dialogs={dialogs}
          />
        )}
      </AppContentWrapper>

      {/* DIALOGS */}
      <SondertageDialogs
        dialogs={dialogs}
        actions={actions}
        selectedSchoolyear={selectedSchoolyear}
        selectedSonderEvent={selectedSonderEvent}
        schoolyears={schoolyears}
        sondertagTemplates={sondertagTemplates}
        sonderEventTemplates={sonderEventTemplates}
        sondertage={sondertage}
      />

      {/* ✅ ALERTS */}
      <SondertageAlerts
        showUnlockedToast={showUnlockedToast}
        setShowUnlockedToast={setShowUnlockedToast}
        errorMessage={errorMessage}
        setErrorMessage={setErrorMessage}
      />
    </Box>
  );
}

export default memo(SondertageContent);
